// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#customer-list[data-v-907503d4]  .table.b-table>tbody>tr.b-table-details>td{padding:0!important}", ""]);
// Exports
module.exports = exports;
